export default function ApiUrl() {
    const API_URL = 'https://365euroapi.vincent365.nl:443/'
    return API_URL
}
